import { IRecord } from "./schema"
interface IBranchSettings {
  defaultStockLocation?: string
  goodsInTransitWarehouse: { id: string }
  barScanOrders: boolean
  allowOrderRequestConsolidation: boolean
}
export type IOrder = IRecord<
  "orders",
  | "internal_branch_transfer_json"
  | "internal_branch_transfer_json_response"
  | "delivery"
  | "internal_branch_transfer_status"
  | "delivery_method"
  | "consolidated_orders_key"
  | "customer"
  | "barScanPartShip"
  | "sage_order_number"
  | "identifier"
  | "sage_exported_at"
> & {
  exportedByUser?: IRecord<"skeem_users"> & {
    beta_features?: { canConsolidateInternalOrders?: boolean }
  }
  warehouseOverride?: IRecord<"warehouses", "disable_barscan"> | null
  orderRequest:
    | (IRecord<"orderRequests", "ship_to_branch" | "purchase_order"> & {
        created_by_branch: IRecord<"branches"> & { settings: IBranchSettings }
        received_by_branch: IRecord<"branches"> & { settings: IBranchSettings }
        created_by_user?: IRecord<"skeem_users"> & {
          beta_features?: { canConsolidateInternalOrders?: boolean }
        }
      })
    | null
  branch: IRecord<"branches"> & {
    settings: IBranchSettings
    warehouses: IRecord<"warehouses", "importer_id" | "name">[]
  }
  partially_exporteded_count: number
  user: IUser
  items: IItem[]
  all_items: IItem[]
  internal_transfer_to_branch: IRecord<"branches"> & { settings: IBranchSettings }
  internal_branch_transfer_json?: {
    source?: IInternalOrderTransferDataWrapper[]
    target?: IInternalOrderTransferDataWrapper
  }
  internal_branch_transfer_json_response?: {
    source?: IInternalTransferResponseItemError
    target?: IInternalTransferResponseItemError
  }
}
export type IUser = IRecord<"skeem_users", "name" | "skeem_email">
export type IProduct = IRecord<"products", "sage_id">
export type IProductLocation = IRecord<"product_locations", "free_stock" | "specific_location"> & {
  warehouse: IRecord<"warehouses", "importer_id">
}
export type IItem = IRecord<
  "order_items",
  | "stock_code"
  | "type"
  | "quantity"
  | "received_quantity"
  | "body"
  | "internal_order_exported"
  | "order"
> & {
  product_location: IProductLocation
  product: IProduct
}

export interface IInternalOrderTransferDataWrapper {
  generatedOn: Date
  itemIds: string[]
  warehouseId: string
  data: IWarehouseTransferRequestDTO
}

export interface IWarehouseTransferRequestDTO {
  bsmWarehouseTransferID?: number
  warehouseIDFrom?: number
  warehouseIDTo: number
  dateRequested?: Date
  requestedBy: string
  error?: string
  lines: IWarehouseTransferRequestLineDTO[]
  // Only sent when the branch uses WarehouseTransferRequestV2
  createdDateTime?: Date
  isShunt?: boolean
}

export interface IWarehouseTransferRequestLineDTO {
  warehouseFromID?: number
  itemID?: number
  code: string
  quantity: number
  error?: any
}

export interface IInternalTransferResponseItemResult {
  error?: false
  detail?: never
  request?: IInternalOrderTransferDataWrapper
  response?: IWarehouseTransferRequestDTO
  directDelivery?: boolean
}

export interface IInternalTransferResponseItemError {
  error?: true
  detail?: any
  request?: IInternalOrderTransferDataWrapper
  response?: IWarehouseTransferRequestDTO
}

export type IInternalTransferResponseItem =
  | IInternalTransferResponseItemResult
  | IInternalTransferResponseItemError

export interface IUpdateWarehouseTransferRequestDTO {
  TransferID: string
  StatusID: number
  "x-Device-Id": "EOS"
}

export interface IWarehouseTransferDeliveryLineDTO {
  warehouseTransferLineID: number
  quantityDelivered: number
  warehouseID?: number
  binItemID?: number
}

export interface ITrackingDTO {
  salesOrderNumber: string | null
  deliveryNoteNumber: string | null
  warehouseTransferNumber: string | null
  trackingNumber: string | null
  trackingMethod: string | null
  dateCreated: string | null
}

export interface IWarehouseTransferDTO {
  bsmWarehouseTransferID?: number
  warehouseIDFrom?: number
  warehouseIDTo?: number
  dateRequested?: string
  requestedBy: string
  statusID: number
  createdDateTime: string
  trackingInfo: string | null
  noOfParcels: number | null
  weight?: number | null
  dateDespatched?: string | null
  dateReceived?: string | null
  lines: IWarehouseTransferLineDTO[]
  status: string
  error?: string
}

export interface IWarehouseTransferLineDTO {
  bsmWarehouseTransferLineID?: number
  bsmWarehouseTransferID?: number
  warehouseFromID?: number
  itemID?: number
  code: string
  quantity?: number
  quantityPicked?: number
  quantityDespatched?: number
  quantityReceived?: number
}

export interface IDeliveredLinesDTO {
  DespatchID: number
  despatchLineID: number
  Reference: string
  StockCode: string
  QuantityReceived: number
  Result: string
}

export const iOrderAttrs = [
  "sage_order_number",
  "consolidated_orders_key",
  "delivery",
  "internal_branch_transfer_json",
  "internal_branch_transfer_json_response",
  "internal_branch_transfer_status",
  "delivery_method",
  "barScanPartShip",
  "identifier",
  "customer",
  "sage_exported_at",
  { name: "exportedByUser", attributes: ["beta_features"] },
  { name: "warehouseOverride", attributes: ["disable_barscan"] },
  {
    name: "orderRequest",
    attributes: [
      "ship_to_branch",
      "purchase_order",
      { name: "created_by_user", attributes: ["beta_features"] },
      { name: "created_by_branch", attributes: ["settings"] },
      { name: "received_by_branch", attributes: ["settings"] },
    ],
  },
  {
    name: "branch",
    attributes: ["settings", { name: "warehouses", attributes: ["name", "importer_id"] }],
  },
  { name: "internal_transfer_to_branch", attributes: ["settings"] },
  { name: "user", attributes: ["name", "skeem_email"] },
  {
    name: "items",
    attributes: [
      "order",
      "internal_order_exported",
      {
        name: "product_location",
        attributes: [
          "free_stock",
          "specific_location",
          { name: "warehouse", attributes: ["importer_id"] },
        ],
      },
      "stock_code",
      "body",
      "type",
      "quantity",
      "received_quantity",
      { name: "product", attributes: ["sage_id"] },
    ],
  },
]
